<header [id]="sectionFragment" class="d-flex justify-content-between align-items-center mb-2 pt-7">
    <h3 class="text-capitalize text-navy-blue">Delete account</h3>
</header>
<hr class="mb-4" />

<div class="delete-account-content mb-6">
    <span class="delete-message text-navy-blue">
        If you no longer need your PBS LearningMedia account, you can permanently delete it here.
    </span>
    <button
        type="button"
        class="btn fw-bold font-size-14 px-4 py-2 delete-account-btn selenium-delete-account-btn"
        (click)="openDeleteAccountModal()"
    >
        <app-icon [type]="'Trash'"></app-icon>
        Delete Account
    </button>
</div>
